import { injectable, inject } from 'inversify';
import { Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import * as Api from "@/app/interaction/api";
//import { QuestionBankService, QuestionBankServiceSymbol } from '@/app/question/question-bank-service';
import { createInteractionComponent } from '@/app/interaction/ui'
//import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
//import { QuestionAnswer } from '@/app/shared/models';
import { queryElements, appendElement, replaceWithElement } from '@/app/shared/utils/content-utils';
//import { createEvent } from '@/app/event-stream';
//import { QuestionAnsweredEvent, QuestionAnsweredEventName } from '@/app/question/events/question-events';
//import PageQuestionComponent from '@/app/presenter/components/page-question-component.vue';
//import { dispatchObjectCompletedEvent } from '@/app/statistics/utils/object-completion-utils';
import { LoadQuestionsJob } from '@/app/question/store';
import { QuestionInteractionContent } from './question-content'
import { QuestionInteractionState } from './question-interaction-state'
//import stringStripHtml from 'string-strip-html'
import { ok } from '@xlearn/common';
import { reportNonFatalError } from '@/app/error-handling';

@injectable()
export class IncludeQuestionsHandler implements Api.IncludeComponentsHandlerInterface {

  // @inject(QuestionBankServiceSymbol)
  // private questionBankService: QuestionBankService;

  @inject(LoadQuestionsJob)
  private loadQuestionsJob: LoadQuestionsJob;

  // @inject(EventStreamSymbol)
  // private eventStream: EventStream;

  public async includeComponents($parsedContent: any, cancel: Api.CancelToken): Promise<Vue[]> {
    const questionElements: any = queryElements('.question.component', $parsedContent);
    if (questionElements === null) {
      return [];
    }

    let components = []
    for (const questionElement of questionElements) {
      const $questionElement: any = $(questionElement);
      const questionId: string|undefined = $questionElement.attr('data-question-id');
      if (!questionId) {
        continue;
      }

      const componentResult = await this.includeComponent2(questionId, cancel);
      if (!componentResult.success) {
        const error = componentResult.error
        if (error !== 'canceled') {
          reportNonFatalError(error)
        }
        continue
      }
      
      components.push(componentResult.value)
    }

    return components
  }

  private async includeComponent2(questionId: string, cancel: Api.CancelToken) {

    const loadResult = await this.loadQuestionsJob.execute([questionId], cancel);
    if (!loadResult.success) {
      return loadResult
      // TODO: implement proper error handling
//      throw new Error(`Error loading question '${questionId}', error: '${loadResult.error}'`);
    }

    const title = ''
    const instruction = ''
    const [ question ] = loadResult.value
    const interactionComponent = createInteractionComponent<QuestionInteractionContent, QuestionInteractionState>(
      questionId,
      'question', {
        title,
        instruction
      }, {
        question
      })
    interactionComponent.$mount();

    const selector: string = `[data-question-id="${questionId}"]`;
    replaceWithElement(selector, interactionComponent.$el);
//    appendElement(selector, component.$el);


    // const component = new PageQuestionComponent({
    //   propsData: {
    //     question
    //   }
    // });

    // component.$on('answer-changed', (answer: QuestionAnsweredPayload) => {
    //   console.log('CHANGED2', answer)
    // })

    // component.setAnswerEvaluatedListener((
    //   answer: QuestionAnswer,
    //   title: string,
    //   type: string
    // ) => this.onAnswerEvaluated(answer, title, type));

//    component.$mount();

//    const selector: string = `[data-question-id="${questionId}"]`;

    return ok(interactionComponent)
  }

  // private onAnswerEvaluated(answer: QuestionAnswer, title: string, type: string): void {
  //   const questionId: string = answer.questionId;
  //   const payload: QuestionAnsweredEvent = {
  //     id: questionId,
  //     title: stringStripHtml(title).result,
  //     type,
  //     response: '', // TODO
  //     score: answer.score,
  //     durationSeconds: 0, // TODO
  //     timestamp: dayjs().toDate()
  //   };
  //   const event = createEvent<typeof QuestionAnsweredEventName, QuestionAnsweredEvent>(
  //     QuestionAnsweredEventName,
  //     payload
  //   );
  //   this.eventStream.dispatch(event);

  //   dispatchObjectCompletedEvent(questionId);
  // }
}
